import {
    SAVE_ALL_PO, SAVE_PART_DETAILS, SAVE_PO_DROPDOWN_LISTS
  } from "Constants/actionConstants";
  
  const initialState = {
    ordersData: [],
    totalCount: '',
    poStatusCount: {},
    poDropdownLists: {},
    partDetails: []
  };
  
  const PODetails = (state = initialState, { type, payload }) => {
    switch (type) {
      case SAVE_ALL_PO: {
        return {
          ...state,
          ordersData: payload && payload.data || [],
          totalCount: payload && payload.totalCount || '',
          poStatusCount: payload && payload.poStatusCount || {}
        };
      }
      case SAVE_PO_DROPDOWN_LISTS: {
        return {
            ...state,
            poDropdownLists: payload || {}
          };
      }
      case SAVE_PART_DETAILS: {
        return {
          ...state,
          partDetails: payload || []
        }
      }
      default:
        return state;
    }
  };
  
  export default PODetails;
  